import { Box, Grid, SxProps } from '@mui/material';
import { Typography } from '@material-ui/core';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';

export interface TripScoreType {
  id: string;
  title: string;
  icon: any;
  number: number;
  caption: string;
  originalNumber?: number;
  indicatorType?: 'greater-is-best' | 'lower-is-best';
}
interface TripsScoreCardProps {
  scores: TripScoreType[];
}

export default function TripsScoreCard({ scores }: TripsScoreCardProps) {
  let somethingToDisplay: boolean = Boolean(scores?.length);
  if (!somethingToDisplay) return <></>;
  const sx: SxProps = {
    display: 'inline-block',
    '.trips-score-card': {
      backgroundColor: 'rgba(4,4,4,0.5)',
      color: 'white',
      borderRadius: '4px',
      '.trips-score-card-icon': {
        width: 32,
        height: 32,
        color: '#ccc',
      },
      '.trips-score-card-number': {
        fontSize: '24px',
        lineHeight: '30px',
      },
      '.trips-score-card-caption': {
        fontSize: '14px',
        color: '#eee',
      },
      '.trips-score-card-title': {
        fontSize: '12px',
        color: '#ccc',
      },
      '.trips-score-card-indicator': {
        // fontSize: '',
        display: 'flex',
        alignItems: 'center',
        '&.green': {
          color: 'lightgreen',
        },
        '&.red': {
          color: '#ff7e68',
        },
        '&.gray': {
          display: 'none',
        },
      },
    },
  };

  return (
    <Box p={2} gap={1} sx={sx} flexDirection={'column'}>
      {scores.map((score, index) =>
        score.number === 0 && !score.originalNumber ? <></> : <ScoreCard {...score} key={`scoreCard-${index}`} />,
      )}
    </Box>
  );
}

function ScoreCard(attrs: {
  title: string;
  icon: any;
  number: number;
  caption: string;
  originalNumber?: number;
  indicatorType?: 'greater-is-best' | 'lower-is-best';
}) {
  const indicator = attrs.originalNumber ? attrs.number - attrs.originalNumber : undefined;
  const colorClass = indicator
    ? attrs.indicatorType == 'lower-is-best'
      ? indicator < 0
        ? 'green'
        : 'red'
      : indicator > 0
      ? 'green'
      : 'red'
    : 'gray';
  return (
    <Grid item className="trips-score-card" mt={1}>
      <Grid container flexDirection="column">
        {attrs.title && (
          <Grid item p={1} pb={0} className="trips-score-card-title">
            {attrs.title}
          </Grid>
        )}
        <Grid item>
          <Grid container gap={1} p={1} pt={0} flexWrap="nowrap" alignItems="start">
            <attrs.icon className="trips-score-card-icon" />
            <Grid item>
              <Grid container flexDirection="column">
                <Grid item>
                  <Grid container alignItems="end" gap={1}>
                    <Typography variant="subtitle1" className="trips-score-card-number">
                      {attrs.number.toFixed(0)}
                    </Typography>
                    <Typography variant="caption" className="trips-score-card-caption">
                      {attrs.caption}
                    </Typography>
                  </Grid>
                </Grid>
                {Boolean(indicator) && (
                  <Typography variant="caption" className={`trips-score-card-indicator ${colorClass}`}>
                    {(indicator ?? 0) >= 0 ? <ArrowDropUp /> : <ArrowDropDown />}
                    {Math.abs(indicator ?? 0).toFixed(0)}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
